/* ------------------------------------------------------------------ */
/* Constants                                                          */
/* ------------------------------------------------------------------ */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const POLICY_REGEX = {
  length: /.{8,}/,
  upper: /[A-Z]/,
  lower: /[a-z]/,
  number: /\d/,
  special: /[^A-Za-z\d]/,
};
/** One month, in milliseconds. */
export const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1_000;

export const LANGS = [
  { code: "en-GB", label: "English (UK)", flag: "🇬🇧" },
  { code: "en-US", label: "English (US)", flag: "🇺🇸" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
];

// src/utils/constants.ts

export const QuestionnaireSlug = "cat" | "sgrq";

export const QUESTIONNAIRES = [
  { slug: "cat", labelKey: "questionnaires.cat" },
  { slug: "caat", labelKey: "questionnaires.caat" },
  { slug: "sgrq", labelKey: "questionnaires.sgrq" },
  { slug: "r-scale", labelKey: "questionnaires.r-scale" },
  { slug: "act", labelKey: "questionnaires.act" },
  { slug: "copd-ps", labelKey: "questionnaires.copd-ps" },
  {
    slug: "weekly-check-in",
    labelKey: "questionnaires.weekly-check-in",
  },
  {
    slug: "monthly-check-in",
    labelKey: "questionnaires.monthly-check-in",
  },
];

export const RECERT_MONTHS = 1;
export const RECERT_MS = RECERT_MONTHS * 30 * 24 * 60 * 60 * 1000; // pragmatic 30 days
export const TTL_MS = 10 * 60 * 1000;

export const MEASUREMENT_VARIANTS = [
  "RecordingSpirometry",
  "RecordingPulseScan",
  "RecordingTidalBreathing",
  "RecordingPostExertion",
  "RecordingSixMinuteWalk",
  "RecordingManualAudio",
];

export const SPIROMETRY_TREND_METRICS = {
  FEV1: {
    valueKey: "fev1",
    rangeKey: "fev1",
    labelKey: "results.spiro.fev1",
    labelFallback: "FEV1",
    averageKey: "results.spiro.fev1Average",
    averageFallback: "FEV1 (Avg)",
    unit: "L",
    decimals: 2,
  },
  FVC: {
    valueKey: "fvc",
    rangeKey: "fvc",
    labelKey: "results.spiro.fvc",
    labelFallback: "FVC",
    averageKey: "results.spiro.fvcAverage",
    averageFallback: "FVC (Avg)",
    unit: "L",
    decimals: 2,
  },
  FEV1_FVC: {
    valueKey: "fev1FvcRatio",
    rangeKey: "fev1FvcRatio",
    labelKey: "results.spiro.fev1FvcRatio",
    labelFallback: "FEV1/FVC",
    averageKey: "results.spiro.fev1FvcRatioAverage",
    averageFallback: "FEV1/FVC (Avg)",
    unit: "",
    decimals: 2,
  },
  PEF: {
    valueKey: "pef",
    rangeKey: "pef",
    labelKey: "results.spiro.pef",
    labelFallback: "PEF",
    averageKey: "results.spiro.pefAverage",
    averageFallback: "PEF (Avg)",
    unit: "L/min",
    decimals: 0,
  },
  RR: {
    valueKey: "rr",
    rangeKey: "rr",
    labelKey: "results.cardio.rr",
    labelFallback: "RR",
    averageKey: "results.cardio.rrAverage",
    averageFallback: "RR (Avg)",
    unit: "bpm",
    decimals: 0,
  },
};
